import { LEGAL_COMPANY_INFO } from "./legalConfig";
import { openCookiePreferences } from "./CookieConsentBanner";

export const LegalFooter = ({ compact = false }: { compact?: boolean }) => {
  if (compact) {
    return (
      <footer
        role="contentinfo"
        aria-label="Informações legais e privacidade"
        className="mt-8 pt-4 pb-2 border-t border-border/60 text-[11px] text-muted-foreground flex flex-col sm:flex-row items-center justify-between gap-2"
      >
        <div className="flex flex-wrap items-center gap-x-3 gap-y-1">
          <span>
            <strong>{LEGAL_COMPANY_INFO.razaoSocial}</strong> — CNPJ:{" "}
            {LEGAL_COMPANY_INFO.cnpj}
          </span>
          <span className="hidden md:inline">•</span>
          <span>DPO/Encarregado: {LEGAL_COMPANY_INFO.emailDpo}</span>
        </div>

        <nav
          aria-label="Links jurídicos"
          className="flex flex-wrap items-center gap-x-3 gap-y-1 font-medium"
        >
          <a href="#/privacidade" className="hover:text-foreground underline-offset-2 hover:underline">
            Privacidade
          </a>
          <a href="#/termos" className="hover:text-foreground underline-offset-2 hover:underline">
            Termos de Serviço
          </a>
          <a
            href="#/cancelamento-reembolso"
            className="hover:text-foreground underline-offset-2 hover:underline"
          >
            Cancelamento e Reembolso
          </a>
          <a href="#/cookies" className="hover:text-foreground underline-offset-2 hover:underline">
            Política de Cookies
          </a>
          <button
            type="button"
            onClick={openCookiePreferences}
            className="hover:text-foreground underline-offset-2 hover:underline cursor-pointer"
          >
            Preferências de Cookies
          </button>
        </nav>
      </footer>
    );
  }

  return (
    <footer
      role="contentinfo"
      aria-label="Dados da empresa e links legais"
      className="w-full border-t border-border bg-muted/30 py-8 px-4 sm:px-6 text-xs text-muted-foreground"
    >
      <div className="max-w-[72ch] mx-auto flex flex-col md:flex-row justify-between gap-6">
        <div className="space-y-1.5 max-w-md">
          <p className="font-semibold text-foreground">
            {LEGAL_COMPANY_INFO.nomeFantasia} ({LEGAL_COMPANY_INFO.razaoSocial})
          </p>
          <p>
            <strong>CNPJ:</strong> {LEGAL_COMPANY_INFO.cnpj} |{" "}
            <strong>Endereço:</strong> {LEGAL_COMPANY_INFO.enderecoCompleto}
          </p>
          <p>
            <strong>Encarregado de Dados (DPO - Art. 41 LGPD):</strong>{" "}
            {LEGAL_COMPANY_INFO.nomeDpo} ({LEGAL_COMPANY_INFO.emailDpo})
          </p>
          <p>
            <strong>Atendimento e Suporte:</strong>{" "}
            {LEGAL_COMPANY_INFO.emailSuporte} |{" "}
            <strong>Telefone:</strong> {LEGAL_COMPANY_INFO.telefoneContato}
          </p>
        </div>

        <nav
          aria-label="Documentos legais"
          className="no-print flex flex-col sm:flex-row md:flex-col gap-2 font-medium shrink-0"
        >
          <a
            href="#/privacidade"
            className="hover:text-foreground underline-offset-2 hover:underline"
          >
            Política de Privacidade
          </a>
          <a
            href="#/termos"
            className="hover:text-foreground underline-offset-2 hover:underline"
          >
            Termos de Serviço
          </a>
          <a
            href="#/cancelamento-reembolso"
            className="hover:text-foreground underline-offset-2 hover:underline"
          >
            Política de Cancelamento e Reembolso
          </a>
          <a
            href="#/cookies"
            className="hover:text-foreground underline-offset-2 hover:underline"
          >
            Política de Cookies
          </a>
          <button
            type="button"
            onClick={openCookiePreferences}
            className="text-left hover:text-foreground underline-offset-2 hover:underline cursor-pointer text-primary"
          >
            Gerenciar Preferências de Cookies
          </button>
        </nav>
      </div>
    </footer>
  );
};

